export const paymentTypeValues = ["cash", "loan", "lease"];

export interface PaymentTypeDisplayMatrix {
    cash: boolean;
    lease: boolean;
    loan: boolean;
}
